import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/post';

export default {
  getAll(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/post${queryString}`);
  },
  getPost(id) {
    return axios.get(`${base}/single/${id}`);
  },
  approvePost(id) {
    return axios.post(`${base}/approve/${id}`);
  },
  rejectPost(id, rejectionReason) {
    return axios.post(`${base}/reject/${id}`, { rejection_reason: rejectionReason });
  },
  getDeliveryStatusFromPost(post) {
    return this.getDeliveryStatusTextFromPostOptions(post.sent_for_printing, post.dispatched, post.delivered);
  },
  getDeliveryStatusTextFromPostOptions(print, dispatched, delivered) {
    if (delivered) {
      return 'Delivered';
    } if (dispatched) {
      return 'Dispatched';
    } if (print) {
      return 'Sent for printing';
    }

    return 'Pending';
  },
  getPrintStatusTextFromPostOptions(print, dispatched, delivered) {
    if (delivered || print) {
      return 'Printed';
    }

    return 'Requires Printing';
  },
  getPrintQueue() {
    return axios.get(`${base}/print-queue`);
  },
  assignClinician(id, clinition) {
    return axios.post(`${base}/assign-clinician/${id}`, clinition);
  },
  reprintResults(postIds) {
    return axios.get(`${base}/print-queue?postIds=${postIds}`);
  },
  getReplies(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/paginated-replies${queryString}`);
  },
  getPostByQrCodeRef(ref) {
    return axios.get(`${base}/qr-code-ref/${ref}`);
  },
  checkFirstPost(id) {
    return axios.get(`${base}/is-first-digital-post/${id}`);
  },
};
